var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('h2',{staticClass:"title"},[_vm._v("投递方式")]),_c('div',{staticClass:"container"},[_c('div',{staticClass:"mode"},[_c('p',{staticClass:"email-address"},[_vm._v("请将简历投递至邮箱：hr@zealcomm.cn")]),_c('p',{staticClass:"email-title"},[_vm._v("邮件标题：姓名+岗位名称")]),_c('p',{staticClass:"email-mode"},[_vm._v("简历命名格式：姓名+岗位名称")])])])])
}]

export { render, staticRenderFns }